import { PrimaryButton } from "@fluentui/react";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

export const ApplyFilterButton: FC<{ apply: () => void }> = ({ apply }) => (
  <PrimaryButton
    onClick={apply}
    styles={{ root: { border: 0, flex: "0 0 32px", margin: "0 5px" } }}
  >
    <FormattedMessage id="quick-filter.apply-filter" defaultMessage="Run query" />
  </PrimaryButton>
);
